/* Auth Endpoints */
const authEndpoints = {
    meEndpoint: '/api/me',
    loginEndpoint: '/api/signin',
    logoutEndpoint: '/api/signout',
    registerEndpoint: '/api/signup',
    storageTokenKeyName: 'accessToken'
}


/* Menu Endpoints */
const menuEndpoints = {
    getMenus: '/api/menu'
}

export const fetchFilteredLeadsEndpoint = '/api/leads/filter'
export const updateLeadSprintEndpoint = '/api/leads/sprint'


export const leadDataManagementEndpoint = '/api/leads/datamanagement'

/* Lead Endpoints */
const leadEndpoints = {
    getLeads: '/api/leads/getpaginated',    
    getGroupedLeads: '/api/leads/getleadsgroupby',
    createEndpoint: '/api/leads/create',
    updateEndpoint: '/api/leads/update',
    getActivities: '/api/activity/getactivities',
    getNotes: '/api/notes/getnotes',
    byCountry: '/api/leads/bycountry',
    updateActivityEndpoint: '/api/activity/updateactivity',
    deleteActivityEndpoint: '/api/activity/deleteactivity',
    getLeadAccount: '/api/leads/accountdetail/{accountid}/{sprintid}',
    getLeadCompany: '/api/leads/companydetail/{companyname}/{sprintid}',
    getsprintleads: '/api/leads/getsprintleads/{sprintid}',
    getactivityhistory: '/api/leads/getactivityhistory/{leadid}',
    getsingleactivity: '/api/activity/getsingleactivity/{activityid}',
    getactivitymessaging: '/api/activity/getactivitymessaging/{leadid}',
    getplaybookcadence: '/api/leads/getplaybookcadence/{leadid}',
    getactivityoutcomes: '/api/leads/getactivityoutcomes/{leadid}',
    updateactivityoutcome: '/api/activity/updateactivityoutcome',
    updatehotleadendpoint: '/api/leads/updatehotlead',
    getplaybookcadencelist: '/api/leads/getplaybookcadencelist/{leadid}',
    updateleadcadence: '/api/leads/updateleadcadence/{leadid}/{cadenceId}',
    gettwiliotoken: '/api/twilio/gettwiliotoken',
    sendwhatsappmessage: '/api/activity/sendwhatsappmessage',
    sendsmsmessage: '/api/activity/sendsmsmessage',
    sendemailmessage: '/api/activity/sendemailmessage',
    inboundcallleaddetail: '/api/leads/inboundcallleaddetail/{phonenumber}/{searchstring}',
    getsinglelead: '/api/leads/getsinglelead/{leadid}',
    getActivityLeads: '/api/leads/getActivityLeads',
    getactivitytodoleads: '/api/leads/getactivitytodoleads',
    getinboundcalls: '/api/leads/getinboundcalls',
    markinboundcallasreviewed: '/api/leads/markinboundcallasreviewed',
    getactivityperformance: '/api/leads/getactivityperformance',
    getdashboardkpisummary: '/api/leads/getdashboardkpisummary',
    getactivitydashboardlist: '/api/leads/getactivitydashboardlist',
    updatechangeactivity: '/api/activity/updatechangeactivity',
    updatechangecadence: '/api/activity/updatechangecadence',
    updatechangesprint: '/api/activity/updatechangesprint',
    updatechangeowner: '/api/activity/updatechangeowner',
    updateleadnote: '/api/leads/updateleadnote/{leadId}/{notevalue}',
    gettasks: '/api/notes/gettasks',
    marktaskascomplete: '/api/leads/marktaskascomplete/{taskid}',
    createnewtask: '/api/leads/createnewtask',
    gettodaytasks: '/api/notes/gettodaytasks',
    getleadnotesandtasks: '/api/leads/getleadnotesandtasks/{leadid}',
    deletelead: '/api/leads/deletelead/{leadid}',
    getdashboardactivitychart: '/api/leads/getdashboardactivitychart',
    getdashboardactivitydonut: '/api/leads/getdashboardactivitydonut',
    getdashboardaccountpenetration: '/api/leads/getdashboardaccountpenetration',
    getdiscoverycallattendees: '/api/leads/getdiscoverycallattendees',
    createnewattendee: '/api/leads/createnewattendee',
    deleteattendee: '/api/leads/deleteattendee',
    getoutcomeactions: '/api/activity/getoutcomeactions',
    updatechangeactivitydate: '/api/activity/updatechangeactivitydate',
    createreferrallead: '/api/leads/createreferrallead',
    referralleadsearch: '/api/leads/referralleadsearch/{customerid}/{searchstring}',
    assignreferralsearchlead: '/api/leads/assignreferralsearchlead',
    gettemplateselections: '/api/leads/gettemplateselections/{leadid}',
}


export const getLeadEndpoint = '/api/leads/get/{id}'

export const getActivityEndpoint = '/api/activity/getactivity/{id}'


/* Options Endpoints */
const optionsEndpoints = {
    countryEndpoint: '/api/options/country',
    industryEndpoint: '/api/options/industry',
    leadLevelEndpoint: '/api/options/level',
    leadFunctionEndpoint: '/api/options/function',
    leadSourceEndpoint: '/api/options/source',
    accountEndpoint: '/api/options/account',
    leadStageEndpoint: '/api/options/stage',
    sprintEndpoint: '/api/options/sprint',
    regionEndpoint: '/api/options/region',
    ownerEndpoint: '/api/options/owner',
    activityEndpoint: '/api/options/activity',
    newactivityendpoint: '/api/options/newactivity',
    activityOutcomeEndpoint: '/api/options/activityoutcome'
}

export const timezoneOptionsApi = '/api/options/timezones';
export const cultureOptionsApi = '/api/options/cultures'
export const teamsOptionsApi = '/api/options/teams'
export const tenuresOptionsApi = '/api/options/tenures'
export const userLocationsOptionsApi = '/api/options/userlocations'
export const sprintTypeOptionsApiEndpoint = '/api/options/sprinttypes';
export const sprintStatusOptionsApiEndpoint = '/api/options/sprintstatuses';
export const playbookOptionsApiEndpoint = '/api/options/playbooks';
export const customersOptionsApiEndpoint = '/api/options/customers';
export const autocompleteEndpoint = '/api/options/autocomplete'

export const saveCustomerEndpoint = '/api/customers'
export const saveAccountEndpoint = '/api/accounts'
export const loadAccountImageEndpoint = '/api/accounts/images/{id}'
export const saveSprintEndpoint = '/api/sprints'
export const toggleSprintStatusEndpoint = '/api/sprints/status/toggle'
export const licensePlanEndpoint = '/api/licenseplan'
export const saveFilterEndpoint = '/api/leadfilters'
export const shareFilterEndpoint = '/api/leadfilters/share'
export const getLeadFilterEndpoint = '/api/leadfilters/{id}'
export const getUserLeadFiltersEndpoint = '/api/leadfilters'
export const loadUserAvatarEndpoint = '/api/admin/users/images/{id}'
export const addUserApiEndpoint = '/api/admin/users';
export const roleOptionsApiEndpoint = '/api/options/roles';
export const rolesOverviewEndpoint = '/api/admin/roles/list'
export const roleUsersEndpoint = '/api/admin/roles/{id}/users'
export const saveRoleEndpoint = '/api/admin/roles/{id}'
export const rolePermissionsEndpoint = '/api/admin/roles/{id}/permissions'
export const confirmAccountApi = '/api/admin/users/confirm';
export const getUsersEndpoint = '/api/admin/users/getpaginated';
export const toggleUserInRoleEndpoint = '/api/admin/roles/{id}/toggleUser'
export const toggleUserActiveEndpoint = '/api/admin/users/{id}/toggleActive'
export const adminChangePasswordEndpoint = '/api/admin/users/change'
export const userChangePasswordEndpoint = '/api/account/change'
export const sendActivationEndpoint = '/api/admin/users/sendactivation'
export const sendActivationEmailEndpoint = '/api/client/auth/confirmemail/send'
export const confirmEmailEndpoint = '/api/client/auth/confirmemail/confirm'
export const forgotPasswordEndpoint = '/api/auth/password/forgot-password'
export const resetPasswordEndpoint = '/api/auth/password/reset-password'

export const updateAccountEndpoint = '/api/account/{id}/update'
export const getAccountEndpoint = '/api/account'
export const changeRoleEndpoint = '/api/account/change-role/{id}'
export const getSprintsEndpoint = '/api/sprints'
export const getCustomersEndpoint = '/api/customers'
export const getAccountsEndpoint = '/api/accounts';
export const getAllUsersEndpoint = '/api/options/users';

export { menuEndpoints, leadEndpoints, authEndpoints, optionsEndpoints }